import { CN_MARKET } from '../constants';
import { useAppConfigurationContext } from '../contexts/AppConfigurationContext';

export const useIsMarketCN = () => {
  const { tenant } = useAppConfigurationContext();

  return tenant === CN_MARKET;
};
